module.exports = __webpack_public_path__ + "img/Working.ec948419.svg";